import { Market } from '../types/booking'

export const TERMS = {
  kootstra: ['general_kootstra', 'consumer_kootstra', 'payment_kootstra'],
  north_america: ['general_north_america', 'payment_north_america'],
  default: ['general', 'consumer', 'payment']
} as const satisfies Record<Market, string[]>
